import * as React from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { useSelector, useIntl } from '@grandvisionhq/state';
import '../../../state/actions.js';
import '../../../state/add-to-cart/selectors.js';
import '../../../state/bundles/selectors.js';
import '../../../state/bundles/reducer.js';
import { getPrescriptionType } from '../../../state/configurator/selectors.js';
import '../../../state/configurator/reducer.js';
import '../../../state/products/selectors.js';
import '../../../state/products/reducer.js';
import { isNewPrescriptionAndUpload } from '../../../utils/is-new-prescription-upload.js';
import { PupillaryDistanceLink } from './PupillaryDistanceLink.js';

const PupillaryDistanceLinkContainer = ({ className  })=>{
    const prescriptionType = useSelector(getPrescriptionType);
    const { hasLabel , getFormattedLabel  } = useIntl();
    const pdLinkLabelKey = CommerceToolsApi.isPrescriptionFile(prescriptionType) || isNewPrescriptionAndUpload(prescriptionType) ? 'products.glasses.prescription.form.pdMeasurementLink' : 'products.glasses.prescription.form.pdLink';
    const labels = React.useMemo(()=>({
            pdLinkLabel: hasLabel(pdLinkLabelKey) ? getFormattedLabel(pdLinkLabelKey, {
                parseLink: true,
                openLinksInNewTab: true
            }) : undefined
        })
    , [
        hasLabel,
        getFormattedLabel,
        pdLinkLabelKey
    ]);
    return /*#__PURE__*/ React.createElement(PupillaryDistanceLink, {
        className: className,
        labels: labels
    });
};

export { PupillaryDistanceLinkContainer };
//# sourceMappingURL=PupillaryDistanceLinkContainer.js.map
